import { Component, OnInit, Output, EventEmitter, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { MatDialogConfig, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SolarService } from '../../services/solarservice.service';
import { FormGroup, FormBuilder, NgForm, Validators } from '@angular/forms';
import { DateRange, MessageError } from 'base-models';

import { Site, Supervision, SupervisionStatusEnum, InfoSupervis } from 'solar-bo';
import { AlertType } from 'base-models';
import { DateHelper, SortHelper } from 'shtools';
import { EditionEnum } from  'base-models';
import { ErrorcontrolService } from 'basecomponents';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
import { MATERIAL_DATE_FORMATS } from '@solar/shared/MaterialDateFormat';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-ex-supervis-edit',
  templateUrl: './supervis-edit.component.html',
  styleUrls: ['./supervis-edit.component.scss']
  ,providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MATERIAL_DATE_FORMATS},
  ],
})
export class SupervisEditComponent extends SolarBaseComponent  implements OnInit, OnChanges {

 
  SupervisionStatusEnum = SupervisionStatusEnum;
  //model: NgbDateStruct;

  @Output() saveEvent = new EventEmitter<Supervision>();
  @Input() supervision: Supervision;
  @Input() selfload: boolean = true;
  @Input() isnewmodel: boolean = true;
  @Input() canChangeSite: boolean = true;
  editState: EditionEnum = EditionEnum.READ;

  showscheduledDate:boolean=true;

  constructor(
     public solarService: SolarService
    , private fb: FormBuilder
    ,public route: ActivatedRoute
  ) {
    super();
    this.createForm();
  }

  ngOnInit() {
    this.getselectformdata();

    if (this.supervision) {
      this.setForm();
      return;
    }
    if (this.selfload) {
      const id = this.route.snapshot.paramMap.get('id');
      if (id) {
        console.log("this.route.snapshot.paramMap.get('id');", id);
        this.getViewModel(id);
      }
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    const typeChange = changes['supervision'];
    if (typeChange && !typeChange.firstChange && typeChange.previousValue == undefined) {
      this.editState = EditionEnum.EDIT;
      this.configureUI();
    }
  }


  
  uiShowSaveBtn(value?:any):boolean {    
    let auth=this.globService.checkAuthorizationById(value);
    if (!auth){
      return false;
    }
    if (!this.supervision || !this.supervision.info) {
      return false;
    }
    if (this.supervision.info.status == SupervisionStatusEnum.LOCKED
      || this.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
      return false;
    }
    return true;
  }

  configureUI() {

    if (this.editState === EditionEnum.EDIT) {
      this.setForm();
     
    }
    else {
      this.setForm();
      this.canChangeSite=false;
    }
  }

  isvalid() {
    return this.myform.valid && !this.submitted;
  }

  getViewModel(id_supervision): void {
    if (!id_supervision) {
      return;
    }
    this.loadinglist = true;
    this.solarService.supervisionGetById(id_supervision)
      .subscribe(resmodel => this.handleresult(resmodel));
  }

  private handleresult(resmodel: any) {
    this.loadinglist = false;
    this.supervision = resmodel;
    this.editState = EditionEnum.EDIT;
    this.setForm();
    this.configureUI();
  }

  private createForm() {
    let dateNow=new Date();
    this.myform = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      site: [null, [Validators.required]],
      description: [''],
      drone_comments: [''],
      emissivity: ['', [Validators.required, Validators.max(1), Validators.min(0)]],
      results_comments: [''],
      scheduledDate: [dateNow, [Validators.required]],
      supervisionDate: [dateNow, [Validators.required]],
    });
  }

  setForm() {
    if (!this.supervision) {
      return;
    }
    let scheduledDate=this.supervision.info.scheduledDate;
    if (scheduledDate==null){
      scheduledDate=new Date();
    }    
    
    let supervisionDate=this.supervision.info.supervisionDate;
    if (supervisionDate==null){
      supervisionDate=scheduledDate;
    }

    const fields={
      name: this.supervision.name,
      site: this.supervision.site,
      description: this.supervision.description,
      drone_comments: this.supervision.info.drone_comments,
      emissivity: this.supervision.info.emissivity ? this.supervision.info.emissivity : 1,
      results_comments: this.supervision.info.results_comments,
      scheduledDate: scheduledDate,
      supervisionDate: supervisionDate,
    };
    if (this.supervision.site){
      this.canChangeSite=false;
    }

    this.myform.reset(fields);



    //|| this.supervision.info.status==SupervisionStatusEnum.TOVALIDATE when supervision is in this state we supose that supervision was made.
    // after all the supervision date will be change by images dates.
    if (this.supervision.info.status==SupervisionStatusEnum.TOVALIDATE
      || this.supervision.info.status==SupervisionStatusEnum.VALIDATED 
      || this.supervision.info.status==SupervisionStatusEnum.READYTOVALIDATE
      || this.supervision.info.status==SupervisionStatusEnum.LOCKED     
      ){
        this.toggleCtrState("scheduledDate",false);
      }
  }

  scheduledDate_change($event){
    console.log($event);
    console.log("Value:" ,$event.target.value);
    
    if (this.supervision.info.status==SupervisionStatusEnum.TOVALIDATE
      || this.supervision.info.status==SupervisionStatusEnum.VALIDATED 
      || this.supervision.info.status==SupervisionStatusEnum.READYTOVALIDATE
      || this.supervision.info.status==SupervisionStatusEnum.LOCKED     
      ){
        return;
      }
      let date=$event.target.value;
      const ctrl = this.myform.get("supervisionDate");
      if (date instanceof _moment){
        console.log("is moment");
      }
      else{
        date=_moment(date);
      }
      ctrl.setValue(date);
  }

  toggleCtrState(control:string, status:boolean) {
    const ctrl = this.myform.get(control);
    if (!ctrl){
      return;
    }
    if (status) {
      ctrl.enable();
    } else {
      ctrl.disable();
    }
  }

  //function used by optionlist
  optionlist_comparesite(opt1: any, opt2: any) {
    let res = opt1 && opt2 ? opt1.id === opt2.id : opt1 === opt2;
    return res;
  }

  prepareSave(): any {
    //como ejemplo, en nuestro caso es el mismo objeto
    const formModel = this.myform.value;
    const cloneModel: Supervision = new Supervision();

    if (this.supervision && this.supervision.id) {
      cloneModel.id = this.supervision.id;
      cloneModel.info.creation_date = new Date();
      cloneModel.info.created_by = this.globService.currentUserValue.id;
    }
    console.log(formModel.site);
    cloneModel.id_site = formModel.site.id;
    cloneModel.site = formModel.site;
    cloneModel.name = formModel.name;
    cloneModel.description = '' + formModel.description;
    cloneModel.info.drone_comments = '' + formModel.drone_comments;
    cloneModel.info.updating_date = new Date();
    cloneModel.info.updated_by = this.globService.currentUserValue.id;
    cloneModel.info.emissivity = formModel.emissivity;
    cloneModel.info.results_comments = '' + formModel.results_comments;
    cloneModel.info.scheduledDate = formModel.scheduledDate;
    cloneModel.info.supervisionDate = formModel.supervisionDate;
    return cloneModel;
  }

  saveModel(value?: any) {
    this.submitted = true;
    this.loadinglist = true;
    this.alertmessage = null;

    try {
      console.log("Supervision-Edit saveModel start", this.supervision);
      const clonemodel = this.prepareSave();
      this.solarService.supervisionEditCreate(clonemodel)
        .subscribe((resmodel) => this.savehandleresult(resmodel, clonemodel)
          , err => this.savehandleError(err)
        );
    } catch (error) {
      this.alertmessage = ErrorcontrolService.basichandleError("", error);
      console.log(error);
    }
  }

  private savehandleresult(resultmodel: Supervision, clonemodel: Supervision) {
    console.log("supervision saved", resultmodel);
    this.submitted = false;
    this.loadinglist = false;
    this.alertmessage = new MessageError(AlertType.Success, 'Supervision saved ');

    if (this.supervision == null || !this.supervision.id) {
      //creando
      this.supervision = resultmodel;           
    }
    else {
      //editando asignamos los valores que necesitamos, porque no sabemos si el servicio devuelve todo o solo lo que interesa.
      this.supervision.name = resultmodel.name;
      this.supervision.description = resultmodel.description;
      this.supervision.info.drone_comments = resultmodel.info.drone_comments;
      this.supervision.info = resultmodel.info;
      this.supervision.site.id = resultmodel.id_site;
      this.supervision.site.name = clonemodel.site.name;
      this.supervision.info.results_comments = clonemodel.info.results_comments;
      //si hay otros campos que necesitamos actualizar hay que añadirlos aqui

    }
    this.saveEvent.emit(this.supervision);
  }

  savehandleError<T>(err: any) {
    this.handleError(err);
  }

  handleError<T>(err: any) {
    this.submitted = false;
    this.loadinglist = false;
    this.alertmessage = ErrorcontrolService.basichandleError("", err);
    console.error('An error occurred:', err.message);
  }
  /**
   * Get data for form
   */
  getselectformdata() {
    this.getSiteList();
  }

  sites: Site[] = [];
  getSiteList(): void {
    this.loadinglist = true;
    this.solarService.sitesGetAll()
      .subscribe(
        sitelist => this.getSiteListhandleresult(sitelist)
        , err => this.getSiteListhandleError(err)
      );
  }

  getSiteListhandleresult(newlist: any[]) {
    this.loadinglist = false;
    if (newlist==null){
      this.sites =null;
      this.alertmessage = null;
      return;
    }
    this.sites = newlist.sort((a, b) => SortHelper.sortByString(a.name, b.name));
    this.alertmessage = null;
  }

  getSiteListhandleError<T>(err: any) {
    console.log("getListhandleError");
    this.loadinglist = false;
    this.alertmessage =ErrorcontrolService.basichandleError("Error getting sites:", err);
  }

}
